import Component from './Header.vue';

export default {
  install(Vue) {
    Vue.component('BkfVHeader', Component);
  },
};
